import { diaCurto } from '../../utils/date';

/** Volume de eventos por dia — série única.
 *
 *  Decisões que não são de gosto:
 *  - uma série = uma cor e nenhuma legenda (o título do cartão já diz o que é);
 *  - rótulo direto só no pico, o resto sai no tooltip de hover (número em toda barra polui);
 *  - eixo e grade recessivos (cinza fino), porque o dado é a barra, não a moldura;
 *  - tabela equivalente em visually-hidden: quem usa leitor de tela recebe os números,
 *    não um "gráfico" mudo.
 */
export default function GraficoEventosDia({ dados = [], altura = 168 }) {
  if (!dados.length) {
    return (
      <div className="empty-state" style={{ padding: 30 }}>
        <i className="bi bi-bar-chart" />
        <div>Nenhum evento recebido no período.</div>
      </div>
    );
  }

  const maximo = Math.max(...dados.map((d) => d.total), 1);
  const indicePico = dados.findIndex((d) => d.total === maximo);
  const total = dados.reduce((soma, d) => soma + d.total, 0);

  return (
    <div>
      <div
        className="grafico"
        style={{ height: altura }}
        role="img"
        aria-label={`Eventos por dia: ${total} evento(s) entre ${dados[0].dia} e ${dados[dados.length - 1].dia}.`}
      >
        {dados.map((d, i) => (
          <div key={d.dia} className="grafico__col" tabIndex={0} aria-hidden="true">
            <span className="grafico__tooltip">
              {diaCurto(d.dia)} · {d.total} evento(s)
            </span>
            {i === indicePico && d.total > 0 && (
              <span style={{ fontSize: 11, fontWeight: 700, textAlign: 'center', color: 'var(--wh-ink-2)' }}>
                {d.total}
              </span>
            )}
            <div
              className="grafico__barra"
              // dia sem evento não desenha marca nenhuma (minHeight 0): uma barrinha de 2px em
              // todo dia zerado vira uma linha tracejada que parece dado onde não há dado
              style={{
                height: d.total > 0 ? `${Math.max((d.total / maximo) * 100, 3)}%` : 0,
                minHeight: d.total > 0 ? 2 : 0,
              }}
            />
          </div>
        ))}
      </div>
      <div className="grafico__eixo">
        <span>{diaCurto(dados[0].dia)}</span>
        {dados.length > 2 && <span>{diaCurto(dados[Math.floor(dados.length / 2)].dia)}</span>}
        <span>{diaCurto(dados[dados.length - 1].dia)}</span>
      </div>

      <table className="visually-hidden">
        <caption>Eventos recebidos por dia</caption>
        <thead>
          <tr>
            <th scope="col">Dia</th>
            <th scope="col">Eventos</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((d) => (
            <tr key={d.dia}>
              <td>{d.dia}</td>
              <td>{d.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
